class ChassisTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.chassis-tabs__button');
    this.panels = this.querySelectorAll('.chassis-tabs__panel');
    
    // Get all containers
    this.specSheet = this.querySelector('.spec-sheet');
    this.datasheet = this.querySelector('.datasheet');
    this.gpuSupport = this.querySelector('.gpu-support');
    this.nvme = this.querySelector('.nvme');
    
    // Parse all data attributes
    this.specs = JSON.parse(this.getAttribute('data-specs') || '[]');
    this.datasheetData = JSON.parse(this.getAttribute('data-datasheet') || '[]');
    this.gpuSupportData = JSON.parse(this.getAttribute('data-gpu-support') || '[]');
    this.nvmeData = JSON.parse(this.getAttribute('data-nvme') || '[]');
    
    this.bindEvents();
    this.renderAllTabs();
  }

  bindEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => this.switchTab(button));
    });
  }

  switchTab(selectedButton) {
    const targetPanel = selectedButton.dataset.tab;

    this.buttons.forEach(button => {
      button.classList.toggle('active', button === selectedButton);
    });

    this.panels.forEach(panel => {
      panel.classList.toggle('active', panel.dataset.panel === targetPanel);
    });
  }

  renderAllTabs() {
    this.renderTabContent(this.specSheet, this.specs);
    this.renderTabContent(this.datasheet, this.datasheetData);
    this.renderTabContent(this.gpuSupport, this.gpuSupportData);
    this.renderTabContent(this.nvme, this.nvmeData);
  }

  renderTabContent(container, data) {
    if (!container || !data?.length) return;
    
    // Create product tabs if multiple products exist
    if (data.length > 1) {
      const tabsContainer = document.createElement('div');
      tabsContainer.className = 'product-tabs';
      
      const tabsList = document.createElement('div');
      tabsList.className = 'product-tabs__list';
      
      const tabsContent = document.createElement('div');
      tabsContent.className = 'product-tabs__content';
      
      data.forEach((product, index) => {
        // Create tab button
        const tabButton = document.createElement('button');
        tabButton.className = `product-tabs__button ${index === 0 ? 'active' : ''}`;
        tabButton.textContent = product.productTitle;
        tabButton.dataset.productIndex = index;
        
        // Create tab content
        const tabContent = document.createElement('div');
        tabContent.className = `product-tabs__panel ${index === 0 ? 'active' : ''}`;
        
        // Add click event to tab button
        tabButton.addEventListener('click', () => {
          // Update active states
          tabsList.querySelectorAll('.product-tabs__button').forEach(btn => 
            btn.classList.toggle('active', btn === tabButton)
          );
          tabsContent.querySelectorAll('.product-tabs__panel').forEach(panel => 
            panel.classList.toggle('active', panel === tabContent)
          );
        });
        
        // Render product specifications in the tab content
        this.renderProductTable(tabContent, product.specifications);
        
        // Append elements
        tabsList.appendChild(tabButton);
        tabsContent.appendChild(tabContent);
      });
      
      tabsContainer.appendChild(tabsList);
      tabsContainer.appendChild(tabsContent);
      container.appendChild(tabsContainer);
      
    } else if (data.length === 1) {
      // If only one product, render it directly
      this.renderProductTable(container, data[0].specifications);
    }
  }

  renderProductTable(container, specifications) {
    specifications.forEach(item => {
      const row = document.createElement('div');
      row.className = 'spec-sheet__row';
      
      const label = document.createElement('div');
      label.className = 'spec-sheet__label';
      label.textContent = item.label;
      
      const value = document.createElement('div');
      value.className = 'spec-sheet__value';
      
      if (Array.isArray(item.value)) {
        item.value.forEach(val => {
          value.innerHTML += val + '<br>';
        });
      } else {
        value.textContent = item.value;
      }
      
      row.appendChild(label);
      row.appendChild(value);
      container.appendChild(row);
    });
  }
}

customElements.define('chassis-tabs', ChassisTabs); 